import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 67,
  height: 46,
  flexShrink: 0,
  borderRadius: (p) => p.spacing(0.5),
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  background: (p) => p.palette.common.white,
};
